export default __webpack_public_path__ + "static/media/trianguloVermelhoVazado.1e4af1ef.png";